<div [ngSwitch]="sidebar.active">
  <div class="title-wrapper">
    <span><img [src]="toolImg" alt="" />{{ sidebar.text }}</span>
    <div class="extend-btn">
      <button class="btn btn-extended" (click)="sidebarExpandToggle()">
        <i
          class="fa fa-expand"
          [ngClass]="{ 'fa-expand': !sidebar.grid.extended, 'fa-compress': sidebar.grid.extended }"></i>
      </button>
    </div>
  </div>
  <div class="tool-wrapper">
    <app-header *ngSwitchCase="'header'"></app-header>
    <app-sbeditor-tool-popupscomparator *ngSwitchCase="'popups'"></app-sbeditor-tool-popupscomparator>
    <app-sbeditor-tool-searcher *ngSwitchCase="'searcher'"></app-sbeditor-tool-searcher>
    <app-plugins *ngSwitchCase="'plugins'"></app-plugins>
    <app-map *ngSwitchCase="'map'"></app-map>
    <app-sbeditor-tool-colorinterface *ngSwitchCase="'colors'"> </app-sbeditor-tool-colorinterface>
    <app-sbeditor-tool-multivenue *ngSwitchCase="'multivenue'"></app-sbeditor-tool-multivenue>
    <app-extern *ngSwitchCase="'extern'"></app-extern>
    <app-sbeditor-tool-filters *ngSwitchCase="'filters'"></app-sbeditor-tool-filters>
    <app-vipinfo *ngSwitchCase="'vipinfo'"></app-vipinfo>
    <app-disclaimer *ngSwitchCase="'disclaimer'"></app-disclaimer>
    <app-language *ngSwitchCase="'language'"></app-language>
  </div>
</div>
